import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1cd47366")

_pushScopeId("data-v-1cd47366")
const _hoisted_1 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_2 = { class: "p-field p-grid" }
const _hoisted_3 = { class: "p-col-4" }
const _hoisted_4 = {
  class: "p-col-8",
  id: "pickerField"
}
const _hoisted_5 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_6 = { class: "p-field p-grid" }
const _hoisted_7 = { class: "p-col-4" }
const _hoisted_8 = { class: "p-col-8" }
const _hoisted_9 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_10 = { class: "p-col-4" }
const _hoisted_11 = { class: "p-col-8" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "p-field p-grid" }
const _hoisted_14 = { class: "p-col-4" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_Button = _resolveComponent("Button")!
  const _component_category_picker = _resolveComponent("category-picker")!
  const _component_string_picker = _resolveComponent("string-picker")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.suggestTaxon)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _withDirectives(_createVNode("div", _hoisted_3, [
              _createVNode(_component_Button, {
                class: ["tooltipButton formBox", { required: _ctx.taxonFields[0].required, notRequired: !_ctx.taxonFields[0].required }],
                disabled: "true"
              }, {
                default: _withId(() => [
                  _createVNode(_component_info_button),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.taxonFields[0].title)), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ], 512), [
              [
                _directive_tooltip,
                _ctx.$t(_ctx.taxonFields[0].help),
                void 0,
                { right: true }
              ]
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_category_picker, {
                onSelect: _ctx.select,
                name: _ctx.taxonFields[0].name,
                api: _ctx.taxonFields[0].api,
                filter: _ctx.taxonFields[0].filter,
                clearable: _ctx.taxonFields[0].clearable,
                value: _ctx.taxonFields[0].value == null ? _ctx.taxonFields[0].defaultValue : _ctx.taxonFields[0].value
              }, null, 8, ["onSelect", "name", "api", "filter", "clearable", "value"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.suggestTaxon)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _withDirectives(_createVNode(_component_Button, {
                class: ["tooltipButton formBox", { required: _ctx.taxonFields[1].required, notRequired: !_ctx.taxonFields[1].required }]
              }, {
                default: _withId(() => [
                  _createVNode(_component_info_button),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.taxonFields[1].title)), 1)
                ]),
                _: 1
              }, 8, ["class"]), [
                [
                  _directive_tooltip,
                  _ctx.$t(_ctx.taxonFields[1].help),
                  void 0,
                  { right: true }
                ]
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_category_picker, {
                onSelect: _ctx.select,
                name: _ctx.taxonFields[1].name,
                api: _ctx.taxonid_api,
                filter: _ctx.taxonFields[1].filter,
                clearable: _ctx.taxonFields[1].clearable,
                value: _ctx.taxonFields[1].value == null ? _ctx.taxonFields[1].defaultValue : _ctx.taxonFields[1].value
              }, null, 8, ["onSelect", "name", "api", "filter", "clearable", "value"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_9, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.suggestedFields, (item, key) => {
            return (_openBlock(), _createBlock("div", {
              class: "p-field p-grid",
              key: key
            }, [
              _createVNode("div", _hoisted_10, [
                _withDirectives(_createVNode(_component_Button, {
                  class: ["tooltipButton formBox", { required: item.required, notRequired: !item.required }]
                }, {
                  default: _withId(() => [
                    _createVNode(_component_info_button),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t(item.help),
                    void 0,
                    { right: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_string_picker, {
                  class: "mb-1",
                  onSelect: _ctx.select,
                  name: item.name,
                  value: item.value,
                  placeholder: _ctx.$t(item.placeholder)
                }, null, 8, ["onSelect", "name", "value", "placeholder"])
              ])
            ]))
          }), 128))
        ])),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_Button, {
            class: "p-button-outlined p-button-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.suggestTaxon = !_ctx.suggestTaxon))
          }, {
            default: _withId(() => [
              (_ctx.suggestTaxon)
                ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('form.select_taxon')), 1))
                : (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('form.suggest_taxon')), 1))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
})